import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _extends from "@babel/runtime/helpers/extends";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
/* eslint-disable prettier/prettier */
/* eslint no-restricted-syntax: 0 */
/* eslint no-await-in-loop: 0 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _isEmpty from 'lodash/isEmpty';
import _castArray from 'lodash/castArray';
import _map from 'lodash/map';
import _values from 'lodash/values';
import _omit from 'lodash/omit';
import _keyBy from 'lodash/keyBy';
import _has from 'lodash/has';
import _split from 'lodash/split';
import _join from 'lodash/join';
import _noop from 'lodash/noop';
import _size from 'lodash/size';
import _filter from 'lodash/filter';
import _get from 'lodash/get';
import _set from 'lodash/set';
import _includes from 'lodash/includes';
import _isNumber from 'lodash/isNumber';
import { getSource } from '@tekion/tekion-base/services/apiService';
import FileReader from '@tekion/tekion-base/utils/File.reader';
import { EMPTY_ARRAY, EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';

// Utils
import { getMediaWithSignedUrls } from '@tekion/tekion-base/utils/mediaUtils';
import { getErrorMessage } from '@tekion/tekion-base/utils/errorUtils';
import { uploadFile, getSignedURLs, getSignedThumbnailURLs, getPreSignedUrlBuckets, uploadFileToBucket } from '../../actions/uploadAction';
import { toaster } from '../NotificationWrapper';
import { getMediaConfig, getVideoEncodingParams } from './mediaUploader.utils';
var MAX_FILE_SIZE = 52428800;
var MB_TO_BYTES = 1024 * 1024;
var fileSize = function fileSize(file) {
  return file && FileReader.getFileSize(file);
};
var getSanitizedFileName = function getSanitizedFileName(fileName) {
  return _join(_split(fileName, ' '), '_');
};
var fileCount = function fileCount(files) {
  return files.length;
};
export default (function (WrappedComponent) {
  var _class;
  var isGloabal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return _class = /*#__PURE__*/function (_Component) {
    _inherits(HOC, _Component);
    var _super = _createSuper(HOC);
    function HOC() {
      var _this;
      _classCallCheck(this, HOC);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        selectedFiles: EMPTY_ARRAY,
        isUploading: false,
        isFetchingMedia: false
      });
      _defineProperty(_assertThisInitialized(_this), "fileCount", {});
      _defineProperty(_assertThisInitialized(_this), "getSignedUrlsList", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(newMediaList) {
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                if (!_isEmpty(newMediaList)) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return");
              case 2:
                _this.setState({
                  isFetchingMedia: true
                });
                getMediaWithSignedUrls(newMediaList).then(function (mediaToInsert) {
                  _this.addSelectedFilesToState(mediaToInsert);
                })["catch"](function (err) {
                  toaster('error', getErrorMessage(err));
                }).then(function () {
                  _this.setState({
                    isFetchingMedia: false
                  });
                  _this.setFileCount(newMediaList);
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "addSelectedFilesToState", function (media) {
        _this.setState(function (_ref2) {
          var selectedFiles = _ref2.selectedFiles;
          return {
            selectedFiles: selectedFiles.concat(media)
          };
        });
      });
      _defineProperty(_assertThisInitialized(_this), "updateSelectedFiles", function (updatedMedia) {
        var selectedFiles = _this.state.selectedFiles;
        if (!isGloabal) {
          _this.setState(function () {
            return {
              selectedFiles: _map(selectedFiles, function (file) {
                if (file.name && file.name === updatedMedia.name) return updatedMedia;
                return file;
              })
            };
          });
        } else {
          _this.setState(function () {
            return {
              selectedFiles: _map(selectedFiles, function (file) {
                if (file.name && _includes(updatedMedia.name, file.name)) return updatedMedia;
                return file;
              })
            };
          });
        }
      });
      _defineProperty(_assertThisInitialized(_this), "getSignedURL", /*#__PURE__*/function () {
        var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
          var media, mediaId, _ref3$originalFileNam, originalFileName, contentType, shouldRequestSignedThumbnailUrl, mediaIds, fetchSignedURLPromises;
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                media = _ref3.media, mediaId = _ref3.mediaId, _ref3$originalFileNam = _ref3.originalFileName, originalFileName = _ref3$originalFileNam === void 0 ? '' : _ref3$originalFileNam, contentType = _ref3.contentType;
                shouldRequestSignedThumbnailUrl = _this.props.shouldRequestSignedThumbnailUrl;
                mediaIds = _castArray(mediaId);
                fetchSignedURLPromises = [getSignedURLs(getMediaConfig(), mediaIds)()];
                if (shouldRequestSignedThumbnailUrl) fetchSignedURLPromises.push(getSignedThumbnailURLs(getMediaConfig(), mediaIds)());
                return _context2.abrupt("return", Promise.all(fetchSignedURLPromises).then(function (response) {
                  var signedMediaUrls = {};
                  var urls = _get(response[0], 'data') || {};
                  _set(signedMediaUrls, 'url', urls[mediaId]);
                  var errorMessage = _get(response[0], 'error');
                  if (shouldRequestSignedThumbnailUrl) {
                    var thumbnailUrls = _get(response[1], 'data') || {};
                    _set(signedMediaUrls, 'thumbnailUrl', thumbnailUrls[mediaId]);
                    if (_isEmpty(errorMessage)) errorMessage = _get(response[1], 'error');
                  }
                  var updatedDocument = {
                    name: originalFileName,
                    file: media,
                    contentType: contentType
                  };
                  return !_isEmpty(urls) ? _objectSpread(_objectSpread(_objectSpread({}, updatedDocument), signedMediaUrls), {}, {
                    mediaId: mediaId
                  }) : _objectSpread(_objectSpread({}, updatedDocument), {}, {
                    errorMessage: errorMessage,
                    isUploadFailed: true
                  });
                }));
              case 6:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref4.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "mediaUploadFailureCb", function (_ref5) {
        var media = _ref5.media,
          errorMessage = _ref5.errorMessage;
        var selectedFiles = _this.state.selectedFiles;
        var notifyOnError = _this.props.notifyOnError;
        var failedMedia = {
          errorMessage: errorMessage,
          file: media,
          isUploadFailed: true,
          name: media.name
        };
        if (errorMessage) {
          toaster('error', errorMessage);
        }
        var sanitizedFiles = _filter(selectedFiles, function (selectedFile) {
          return selectedFile.name !== failedMedia.name;
        });
        _this.setState({
          selectedFiles: sanitizedFiles
        });
        notifyOnError();
      });
      _defineProperty(_assertThisInitialized(_this), "mediaUploadProgressCb", function (_ref6) {
        var media = _ref6.media,
          progress = _ref6.progress;
        var updatedMedia = {
          file: media,
          isUploading: progress >= 0,
          name: media.name,
          progress: progress,
          cancelSource: media.cancelSource,
          documentId: media.documentId
        };
        _this.updateSelectedFiles(updatedMedia);
      });
      _defineProperty(_assertThisInitialized(_this), "getUpdatedFiles", function (updatedMedia, objectURL) {
        var selectedFiles = _this.state.selectedFiles;
        if (!isGloabal) {
          return _map(selectedFiles, function (file) {
            if (file.name && file.name === updatedMedia.name) return _objectSpread(_objectSpread({}, updatedMedia), {}, {
              objectURL: objectURL
            });
            return file;
          });
        }
        return _map(selectedFiles, function (file) {
          if (file.name && _includes(updatedMedia.name, file.name)) return updatedMedia;
          return file;
        });
      });
      _defineProperty(_assertThisInitialized(_this), "mediaUploadSuccessCb", /*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(_ref7) {
          var media, response, mediaId, originalFileName, contentType, objectURL, mediaThumbnail, onChange, updatedMedia;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                media = _ref7.media, response = _ref7.response;
                // TODO: logger
                mediaId = response.mediaId, originalFileName = response.originalFileName, contentType = response.contentType, objectURL = response.objectURL, mediaThumbnail = response.mediaThumbnail;
                onChange = _this.props.onChange; // adds media to ro form {mediaId, objectURL, contentType}
                if (isGloabal) {
                  _context3.next = 11;
                  break;
                }
                _context3.next = 6;
                return _this.getSignedURL({
                  media: media,
                  mediaId: mediaId,
                  originalFileName: originalFileName,
                  contentType: contentType
                });
              case 6:
                updatedMedia = _context3.sent;
                onChange(_this.getUpdatedFiles(_objectSpread(_objectSpread({}, updatedMedia), {}, {
                  mediaThumbnail: mediaThumbnail
                }), objectURL));
                _this.updateSelectedFiles(_objectSpread(_objectSpread({}, updatedMedia), {}, {
                  mediaThumbnail: mediaThumbnail
                }));
                _context3.next = 13;
                break;
              case 11:
                onChange(_this.getUpdatedFiles(_objectSpread(_objectSpread({}, response), {}, {
                  name: originalFileName
                }), objectURL));
                _this.updateSelectedFiles(_objectSpread(_objectSpread({}, response), {}, {
                  name: originalFileName,
                  isUploading: false
                }));
              case 13:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref8.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "uploadMedia", /*#__PURE__*/function () {
        var _ref9 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(mediaToUpload) {
          var queryOptions,
            shouldRequestThumbnail,
            params,
            mediaUploadPromises,
            _args4 = arguments;
          return _regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) switch (_context4.prev = _context4.next) {
              case 0:
                queryOptions = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : EMPTY_OBJECT;
                shouldRequestThumbnail = _this.props.shouldRequestThumbnail;
                params = shouldRequestThumbnail ? _objectSpread({
                  thumbnail: true
                }, queryOptions) : queryOptions;
                mediaUploadPromises = mediaToUpload.map(function (selectedFile) {
                  return uploadFile(getMediaConfig(_objectSpread(_objectSpread({}, params), getVideoEncodingParams(selectedFile))), selectedFile, _this.mediaUploadProgressCb, _this.mediaUploadSuccessCb, _this.mediaUploadFailureCb, isGloabal)();
                });
                return _context4.abrupt("return", Promise.all(mediaUploadPromises));
              case 5:
              case "end":
                return _context4.stop();
            }
          }, _callee4);
        }));
        return function (_x4) {
          return _ref9.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "addMedia", /*#__PURE__*/function () {
        var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(files, queryOptions) {
          var _this$props, maxFileSize, minFileSize, notifyOnError, mutatedFiles, mediaToUpload, sanitizedMedia;
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                _this$props = _this.props, maxFileSize = _this$props.maxFileSize, minFileSize = _this$props.minFileSize, notifyOnError = _this$props.notifyOnError;
                _this.setState({
                  isUploading: true
                });
                mutatedFiles = _this.mutateFileName(files);
                mediaToUpload = mutatedFiles.map(function (file) {
                  return {
                    file: file,
                    name: file && getSanitizedFileName(file.name),
                    url: FileReader.getFileURL(file),
                    cancelSource: getSource(),
                    documentId: FileReader.getFileURL(file) // this generates unique string everytime
                  };
                });
                sanitizedMedia = maxFileSize ? _filter(mediaToUpload, function (selectedFile) {
                  return fileSize(selectedFile.file) < maxFileSize;
                }) : mediaToUpload;
                if (!(_size(sanitizedMedia) < _size(mediaToUpload))) {
                  _context5.next = 8;
                  break;
                }
                notifyOnError();
                return _context5.abrupt("return", toaster('error', __("Media size should be less than ".concat(maxFileSize / MB_TO_BYTES, "MB"))));
              case 8:
                sanitizedMedia = _isNumber(minFileSize) ? _filter(mediaToUpload, function (selectedFile) {
                  return fileSize(selectedFile.file) > minFileSize;
                }) : mediaToUpload;
                if (!(_size(sanitizedMedia) < _size(mediaToUpload))) {
                  _context5.next = 12;
                  break;
                }
                notifyOnError();
                return _context5.abrupt("return", toaster('error', __("Media size should be greater than ".concat(minFileSize, "MB"))));
              case 12:
                _context5.next = 14;
                return _map(sanitizedMedia, function (media) {
                  return _this.addSelectedFilesToState(media);
                });
              case 14:
                _context5.next = 16;
                return _this.uploadMedia(sanitizedMedia, queryOptions);
              case 16:
                return _context5.abrupt("return", _this.setState({
                  isUploading: false
                }));
              case 17:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x5, _x6) {
          return _ref10.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "uploadMediaToBucket", /*#__PURE__*/function () {
        var _ref11 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(mediaToUpload) {
          var mediaUploadPromises;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                mediaUploadPromises = mediaToUpload.map(function (selectedFile) {
                  return uploadFileToBucket(selectedFile, _this.mediaUploadProgressCb, _this.mediaUploadSuccessCb, _this.mediaUploadFailureCb, getMediaConfig())();
                });
                return _context6.abrupt("return", Promise.all(mediaUploadPromises));
              case 2:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x7) {
          return _ref11.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "addMediaWithPresignedURL", /*#__PURE__*/function () {
        var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(files) {
          var maxFileSize, urlBuckets, mutatedFiles, mediaToUpload, sanitizedMedia;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                maxFileSize = _this.props.maxFileSize;
                _this.setState({
                  isUploading: true
                });
                _context7.next = 4;
                return getPreSignedUrlBuckets(fileCount(files));
              case 4:
                urlBuckets = _context7.sent;
                mutatedFiles = _this.mutateFileName(files);
                mediaToUpload = mutatedFiles.map(function (file, index) {
                  return {
                    file: file,
                    name: file && getSanitizedFileName(file.name),
                    url: FileReader.getFileURL(file),
                    bucket: urlBuckets[index],
                    cancelSource: getSource(),
                    documentId: FileReader.getFileURL(file) // this generates unique string everytime
                  };
                });
                sanitizedMedia = maxFileSize ? _filter(mediaToUpload, function (selectedFile) {
                  return fileSize(selectedFile.file) < maxFileSize;
                }) : mediaToUpload;
                if (!(_size(sanitizedMedia) < _size(mediaToUpload))) {
                  _context7.next = 10;
                  break;
                }
                return _context7.abrupt("return", toaster('error', __("Media size should be ".concat(maxFileSize / MB_TO_BYTES, "MB"))));
              case 10:
                _map(sanitizedMedia, function (media) {
                  return _this.addSelectedFilesToState(media);
                });
                _context7.next = 13;
                return _this.uploadMediaToBucket(sanitizedMedia);
              case 13:
                return _context7.abrupt("return", _this.setState({
                  isUploading: false
                }));
              case 14:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        return function (_x8) {
          return _ref12.apply(this, arguments);
        };
      }());
      _defineProperty(_assertThisInitialized(_this), "removeMedia", function (mediaList) {
        var mediaIdList = _map(_castArray(mediaList), 'mediaId');
        var selectedFiles = _this.state.selectedFiles;
        var onChange = _this.props.onChange;
        var selectedFilesWithMediaId = _keyBy(selectedFiles, 'mediaId');
        var mediaToUpdate = _values(_omit(selectedFilesWithMediaId, mediaIdList));
        onChange(_castArray(mediaToUpdate));
        _this.setState({
          selectedFiles: mediaToUpdate
        });
      });
      _defineProperty(_assertThisInitialized(_this), "onSelection", function (_ref13) {
        var data = _extends({}, (_objectDestructuringEmpty(_ref13), _ref13));
        var checked = data.checked;
        // eslint-disable-next-line no-param-reassign
        data.checked = !checked;
        _this.updateSelectedFiles(data);
      });
      _defineProperty(_assertThisInitialized(_this), "cancelMediaUpload", function (documentId) {
        var selectedFiles = _this.state.selectedFiles;
        selectedFiles.map(function (media) {
          if (media.cancelSource && media.documentId === documentId) {
            media.cancelSource.cancel();
            toaster('error', __('Media Upload Aborted'));
          }
          return null;
        });
        _this.setState(function (prevState) {
          return {
            selectedFiles: _filter(prevState.selectedFiles, function (media) {
              return media.documentId !== documentId;
            })
          };
        });
      });
      return _this;
    }
    _createClass(HOC, [{
      key: "componentDidMount",
      value:
      // eslint-disable-next-line consistent-return
      function componentDidMount() {
        var mediaList = this.props.mediaList;
        if (isGloabal) {
          return this.addSelectedFilesToState(mediaList);
        }
        if (!_isEmpty(mediaList)) {
          this.getSignedUrlsList(mediaList);
        }
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate(prevProps) {
        var assetId = this.props.assetId;
        var prevAssetId = prevProps.assetId;
        if (assetId === prevAssetId) return;
        var mediaList = this.props.mediaList;
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          selectedFiles: EMPTY_ARRAY
        });
        if (isGloabal) {
          this.addSelectedFilesToState(_castArray(mediaList));
        } else this.getSignedUrlsList(_castArray(mediaList));
      }

      /**
       * Function to set the fileCount if files are already present
       */
    }, {
      key: "setFileCount",
      value: function setFileCount(media) {
        var _this2 = this;
        media.forEach(function (file) {
          var fileName = _get(file, 'name', '') || '';
          var match = fileName.match(/(.*)(_Copy-[0-9].*)/);
          var key = match && match[1] || fileName;
          if (_has(_this2.fileCount, key)) {
            _this2.fileCount[key] += 1;
          } else {
            _this2.fileCount[key] = 1;
          }
        });
      }
    }, {
      key: "mutateFileName",
      value:
      // Function to mutate the file name if same name exits
      function mutateFileName(files) {
        var _this3 = this;
        var selectedFiles = this.state.selectedFiles;
        files.forEach(function (file) {
          var fileName = _get(file, 'name', '') || '';
          if (_has(_this3.fileCount, fileName)) {
            _this3.fileCount[fileName] += 1;
          } else {
            _this3.fileCount[fileName] = 1;
          }
          var foundFile = selectedFiles.find(function (currFile) {
            return currFile.name === fileName;
          });
          if (foundFile) {
            foundFile.name = "".concat(FileReader.getFileNameWithoutExtension(foundFile.name), "_Copy-").concat(_this3.fileCount[fileName] - 1, ".").concat(FileReader.getFileExtension(foundFile.name));
          }
        });
        return files;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$state = this.state,
          selectedFiles = _this$state.selectedFiles,
          isUploading = _this$state.isUploading,
          isFetchingMedia = _this$state.isFetchingMedia;
        return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, this.props, {
          addMedia: this.addMedia,
          removeMedia: this.removeMedia,
          mediaList: selectedFiles,
          onSelection: this.onSelection,
          isUploading: isUploading,
          isFetchingMedia: isFetchingMedia,
          cancelMediaUpload: this.cancelMediaUpload,
          addMediaWithPresignedURL: this.addMediaWithPresignedURL
        }));
      }
    }]);
    return HOC;
  }(Component), _defineProperty(_class, "propTypes", {
    onChange: PropTypes.func,
    mediaList: PropTypes.array,
    assetId: PropTypes.string,
    maxFileSize: PropTypes.number,
    shouldRequestThumbnail: PropTypes.bool,
    shouldRequestSignedThumbnailUrl: PropTypes.bool,
    cancelMediaUpload: PropTypes.func,
    minFileSize: PropTypes.number,
    notifyOnError: PropTypes.func
  }), _defineProperty(_class, "defaultProps", {
    onChange: _noop,
    mediaList: EMPTY_ARRAY,
    assetId: '',
    maxFileSize: MAX_FILE_SIZE,
    shouldRequestThumbnail: false,
    shouldRequestSignedThumbnailUrl: false,
    cancelMediaUpload: _noop,
    minFileSize: null,
    notifyOnError: _noop
  }), _class;
});